module.exports = __webpack_public_path__ + "img/milanesa-pan.4d4f8b48.jpeg";